import { useState } from "react";
import { useParams } from "react-router-dom";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { ShemaJsonTemplate } from "types/SchemaJson";
import JsonFormsComponent from "components/CRPComponents/JsonForm/JsonFormsComponent";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import useGetItem from "./hooks/useGetItem";
import { path, SchemaData } from "./hooks/types";

function Update() {
  const id = useParams()?.id;

  const [template, setTemplate] = useState<ShemaJsonTemplate>();
  const [state, setState] = useState<JsonFormsStateProps<SchemaData>>({ loading: true });

  if (!id) return null;

  useGetItem({
    setTemplate,
    setState: setState,
    queryParam: id,
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <JsonFormsComponent
        template={template}
        state={state}
        onChange={setState}
        onSave={() => {
          alert("Não pode editar Log");
          return null;
        }}
        disabled
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Update;
